import { render, staticRenderFns } from "./Quality_policy.vue?vue&type=template&id=0a0bf1ac&scoped=true&"
import script from "./Quality_policy.vue?vue&type=script&lang=js&"
export * from "./Quality_policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0bf1ac",
  null
  
)

export default component.exports